import { render, staticRenderFns } from "./consultDialog.vue?vue&type=template&id=56a733be&scoped=true"
import script from "./consultDialog.vue?vue&type=script&lang=js"
export * from "./consultDialog.vue?vue&type=script&lang=js"
import style0 from "./consultDialog.vue?vue&type=style&index=0&id=56a733be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a733be",
  null
  
)

export default component.exports